import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-query";
import Cookies from "js-cookie";
import axios from "axios";
import styled from "@emotion/styled";
import { HorizontalGap, VerticalGap } from "../styled/gaps";
import { DAY_ORDER, NUMBER_DAY_MAP } from "../common/mappings";
import { Switch } from "@mui/material";
import { DaysSlots } from "./DaysSlots";
import { useUpdateTimingsMutation } from "src/api/timingsApiSlice";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const DaySelector = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
`;

const TimingsForm = (props) => {
  const [data, setData] = useState(props.data);
  const [updateTimings, { isLoading: isUpdating }] = useUpdateTimingsMutation();
  return (
    <DaySelector>
      {data
        ? DAY_ORDER.map((numericDay, idx) => {
            return (
              <>
                <DaysSlots
                  changeHandler={(updatedSlot) => {
                    let newData = JSON.parse(JSON.stringify(data));
                    newData[numericDay] = updatedSlot;
                    setData(newData);
                    updateTimings(newData);
                  }}
                  data={data}
                  numericDay={numericDay}
                />
                {idx != DAY_ORDER.length - 1 ? (
                  <VerticalGap size={"10px"} />
                ) : null}
              </>
            );
          })
        : null}
    </DaySelector>
  );
};

TimingsForm.propTypes = {};

export { TimingsForm };
